import { render, staticRenderFns } from "./SimMovimientosForm.vue?vue&type=template&id=f51583ea&scoped=true&"
import script from "./SimMovimientosForm.vue?vue&type=script&lang=ts&"
export * from "./SimMovimientosForm.vue?vue&type=script&lang=ts&"
import style0 from "./SimMovimientosForm.vue?vue&type=style&index=0&id=f51583ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51583ea",
  null
  
)

export default component.exports